import { Component, Vue, Watch } from 'vue-property-decorator';
import moment from 'moment';
moment.locale('zh-cn');
import changeAirport from '../../../assets/js/airport/changeAirport';
import SelectAir from '@/components/SelectAir.vue';

@Component({
    components: {
      SelectAir,
    },
    filters: {
      Date(data: string) {
        return moment(data).format('MM-DD');
      },
      Week(data: string) {
        return moment(data).format('dddd');
      },
    },
})
export default class AirTicketHelp extends Vue {
  private $api: any;
  private isStartShow: boolean = false; // 是否弹出出发地选择器
  private isEndShow: boolean = false; // 是否弹出目的地选择器
  private startPlace: any = '';  // 出发地
  private endPlace: any = '';    // 目的地
  private startDate: any = moment().format('YYYY-MM-DD');
  private AirTicketHelp: any = '';

  // 时间选择器
  private show: boolean = false;
  private minDate: any = new Date();
  private currentDate: any = new Date();


  // // 监听地址被选择事件
  // // (同时解决chooseStartPlace和chooseEndPlace并不会自动重置为false的问题，否则无法再次弹出选择器)
  // @Watch('startPlace')
  // private onChooseStartPlace() {
  //   this.chooseStartPlace = false;
  // }

  // @Watch('endPlace')
  // private onChooseEndPlace() {
  //   this.chooseEndPlace = false;
  // }

  // 格式化时间
  private formatter(type: string, value: string) {
    if (type === 'year') {
      return `${value}年`;
    } else if (type === 'month') {
      return `${value}月`;
    }
    return `${value}日`;
  }

  // 弹出时间选择器
  private pickDate() {
    this.show = true;
  }

  private changeDate(value: string) {
    this.startDate = moment(value).format('YYYY-MM-DD');
    this.cancel();
  }

  // 取消弹窗
  private cancel() {
    this.show = false;
  }

  private clearDate(event: any) {
    // console.log(event);
    event.stopPropagation(); // 阻止事件冒泡，否则会弹出时间选择器
    this.startDate = '';
    // this.getAirportList();
  }

  // 搜索机票
  private toBooking() {
    const params: any = {
      StartAirport: this.startPlace.airportCode,
      EndAirport: this.endPlace.airportCode,
      StartTime: this.startDate,
    };
    for (const k of Object.keys(params)) {
      if (!params[k]) {
        this.$toast('请输入完整查询条件');
        return;
      }
    }
    const AirTicketHelpParams = {
      Depart: this.startPlace.airportCode,
      Arrive: this.endPlace.airportCode,
      DepartDate: this.startDate,
      Order: 3,
    };
    localStorage.setItem('AirTicketHelp', JSON.stringify(AirTicketHelpParams));
    localStorage.setItem('CurrentTripInfo', JSON.stringify(params));
    this.$router.push('/airticket-booking');
  }

  // 初始化
  private created() {
    this.AirTicketHelp = JSON.parse(localStorage.getItem('AirTicketHelp') || '{}');
    this.startPlace = {
      airportCode: this.AirTicketHelp.Depart, cityCName: changeAirport.changeAirportCode(this.AirTicketHelp.Depart).cityCName,
    };
    this.endPlace = {
      airportCode: this.AirTicketHelp.Arrive, cityCName: changeAirport.changeAirportCode(this.AirTicketHelp.Arrive).cityCName,
    };
    this.startDate = moment(this.AirTicketHelp.DepartDate).isAfter(this.startDate, 'day') ? this.AirTicketHelp.DepartDate : this.startDate;
  }
  

  // 交换起始地和目的地
  private changePlace() {
    const changePlace = this.startPlace;
    this.startPlace = this.endPlace;
    this.endPlace = changePlace;
  }

  // 航班选择取消
  private SelectCancel(place: string) {
    this.isStartShow = false;
    this.isEndShow = false;
  }

  // 关闭出发地弹窗
  private closeStartPop(val: any) {
    this.isStartShow = false;
    if (val) {
      this.startPlace = val;
    }
  }
  // 关闭出发地弹窗
  private closeEndPop(val: any) {
    this.isEndShow = false;
    if (val) {
      this.endPlace = val;
    }
  }
}
